module.exports = __webpack_public_path__ + "assets/img/pj_panda-pointing.2a36b9a0.png";